import React, {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import useGlobalCustomPreferencesListQuery from '../custom-hooks/use-global-custom-preference-list'

export const GlobalCustomPreferencesContext = createContext()

export const GlobalCustomPreferencesProvider = ({children}) => {
    const {data} = useGlobalCustomPreferencesListQuery()

    return (
        <GlobalCustomPreferencesContext.Provider value={data?.data || []}>
            {children}
        </GlobalCustomPreferencesContext.Provider>
    )
}

GlobalCustomPreferencesProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useGlobalCustomPreferences = () => {
    const context = useContext(GlobalCustomPreferencesContext)
    if (!context) {
        throw new Error(
            'useGlobalCustomPreferences must be used within a GlobalCustomPreferencesProvider',
        )
    }
    return context
}
